import { useParams } from 'react-router-dom';
import { FileX2 } from 'lucide-react';

import { DOCUMENT_TYPE } from '@/app/document/enums';
import DocumentPreview from '@/app/document/DocumentPreview';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Card, CardContent } from '@/components/ui/card';
import PageLoader from '@/components/common/PageLoader';

import { useDocuments } from '@/data/document';

const ContractorAgreement = () => {
  const params = useParams();

  const contractDocuments = useDocuments({
    coachId: params.id,
    type: DOCUMENT_TYPE.CONTRACT,
    coachActivityId: params.coachActivityId
  });

  if (contractDocuments.isLoading && !contractDocuments.data) {
    return <PageLoader />;
  }

  const contractDocument = contractDocuments.data.find(
    (doc) => doc.coachActivityId === params.coachActivityId
  );

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Contractor Agreement</h2>
      {!contractDocument && (
        <Alert>
          <FileX2 className="h-4 w-4" />
          <AlertTitle>No Contract Found</AlertTitle>
          <AlertDescription>
            The coach has not signed the contractor agreement yet or the
            document cannot be found.
          </AlertDescription>
        </Alert>
      )}
      {contractDocument && (
        <Card className="flex-auto overflow-hidden">
          <CardContent className="p-0 h-[80vh]">
            <DocumentPreview document={contractDocument} />
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ContractorAgreement;
